import { Component, OnInit } from '@angular/core';
export class ProfileListComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[hd-profile-list]',
  template: `
    <ng-content></ng-content>
  `,
  styles: [`
    :host{
        padding: 0;
        margin: 0;
        margin-top:20px;
        list-style: none;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ProfileListComponent_tsickle_Closure_declarations() {
/** @type {?} */
ProfileListComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProfileListComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
